import React, { useMemo } from "react";

import { useAppointmentsIndex } from "/b2c/query/appointments.b2c";
import { useTranslation } from "/hook";

import {
  ButtonText,
  ProviderNoteContainer,
  RequestButton,
  SubtitleText,
  TitleText,
} from "./DocumentsProviderNote.styles";

const DocumentsProviderNote = () => {
  const { t } = useTranslation("documents");
  const { data, loading, errors } = useAppointmentsIndex({ showPast: true });
  const appointments = data?.patient?.appointments || [];

  const hasRecentAppt = useMemo(() => {
    const now = new Date().getTime();
    const threshold = now - 30 * 24 * 60 * 60 * 1000;

    return appointments.some((appt) => {
      const apptTime = new Date(appt.startDateTime).getTime();
      return apptTime >= threshold && apptTime <= now;
    });
  }, [appointments]);

  if (loading || (errors && errors.length > 0) || !hasRecentAppt) return null;

  return (
    <ProviderNoteContainer>
      <TitleText variant="title3">{t("providerNote.title")}</TitleText>
      <SubtitleText variant="body2">{t("providerNote.subtitle")}</SubtitleText>
      <RequestButton href="https://medicalnote.citymd.com/">
        <ButtonText color="brandPrimary" variant="title3">
          {t("providerNote.button")}
        </ButtonText>
      </RequestButton>
    </ProviderNoteContainer>
  );
};

export default DocumentsProviderNote;
